import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=b0e72b52&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&lang=css&"
import style1 from "./settings.vue?vue&type=style&index=1&id=b0e72b52&scoped=true&lang=css&"
import style2 from "./settings.vue?vue&type=style&index=2&id=b0e72b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e72b52",
  null
  
)

export default component.exports